import NotificationsApi from 'mewe/api/notifications-api';
import NotificationsStore from 'mewe/stores/notifications-store';

export default function () {
  NotificationsApi.unseenNumber().then((data) => {
    NotificationsStore.send('handleUnseenCount', data);
  });
}
